export default __webpack_public_path__ + "static/media/garden.4756ba90.png";